export const BRAND = {
  name: "Six12 Consulting",
  domain: "Six12Consulting.com",
  tagline: "Complexity. Clarity. Confidence.",
  pillars: ["Strategy", "Protection", "Partnership", "Preparation"],
  prism:
    "https://static.prod-images.emergentagent.com/jobs/04aafec5-89a2-40fb-8913-69408800e0f1/images/0df05eb60d27cccb641cd4a2a628c19d9e498ac75e51716e5132f0a0eabc9162.png",
  email: "info@six12consulting.com",
  phone: "+1 (612) 000-0000",
};

export const SERVICES = [
  {
    key: "contracts",
    title: "Contractual Risk Evaluation",
    desc: "Before you sign, we surface the exposure others miss—obligations, liabilities, and terms that could cost you later. Clarity before commitment.",
    icon: "ScrollText",
  },
  {
    key: "ip",
    title: "Intellectual Property Ownership",
    desc: "Who owns what? We untangle authorship, assignment, and rights so your most valuable ideas are protected and unmistakably yours.",
    icon: "Fingerprint",
  },
  {
    key: "funding",
    title: "Funding Eligibility",
    desc: "We assess your position against funding, grant, and capital requirements—then structure your case so you qualify with confidence.",
    icon: "Banknote",
  },
  {
    key: "strategy",
    title: "Strategic Business Decisions",
    desc: "High-stakes choices deserve structure. We frame the options, weigh the trade-offs, and deliver the insight that drives decisive action.",
    icon: "Compass",
  },
];

export const MARK = [
  { label: "The Prism", text: "Perspective and precision. We examine every angle to reveal what matters most." },
  { label: "The Input", text: "Complex information arrives from many directions and forms. We take it all in." },
  { label: "The Analysis", text: "We separate, evaluate, and analyze—bringing structure to complexity." },
  { label: "The Clarity", text: "The prism transforms information into clear, actionable insight." },
  { label: "The Impact", text: "Clarity drives confident decisions. Confidence creates lasting value." },
];

export const TESTIMONIALS = [
  {
    quote:
      "We engaged Angelica to assist us with contract review for R&D tax credit eligibility, and she was a pleasure to work with. She brought a strong understanding of the technical issues, delivered clear results, and met tight turnaround expectations. With her help, we were able to confidently provide our client a greater tax credit than expected.",
    name: "Alex Bagne, JD, CPA, MBA, CCSP",
    role: "President, ICS Tax, LLC",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
